var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfrastructureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 23,
    viewBox: "0 0 14 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.3125 22.5L0 19.75L3.5625 9.9375C3.875 10.2292 4.21354 10.474 4.57812 10.6719C4.94271 10.8698 5.33333 11.0208 5.75 11.125L2.3125 20.5625L0.3125 22.5ZM13.4375 22.5L11.4375 20.5625L8 11.125C8.41667 11.0208 8.80729 10.8698 9.17188 10.6719C9.53646 10.474 9.875 10.2292 10.1875 9.9375L13.75 19.75L13.4375 22.5ZM6.875 10C5.83333 10 4.94792 9.63542 4.21875 8.90625C3.48958 8.17708 3.125 7.29167 3.125 6.25C3.125 5.4375 3.35938 4.71354 3.82812 4.07812C4.29688 3.44271 4.89583 3 5.625 2.75V0H8.125V2.75C8.85417 3 9.45312 3.44271 9.92188 4.07812C10.3906 4.71354 10.625 5.4375 10.625 6.25C10.625 7.29167 10.2604 8.17708 9.53125 8.90625C8.80208 9.63542 7.91667 10 6.875 10ZM6.875 7.5C7.22917 7.5 7.52604 7.38021 7.76562 7.14062C8.00521 6.90104 8.125 6.60417 8.125 6.25C8.125 5.89583 8.00521 5.59896 7.76562 5.35938C7.52604 5.11979 7.22917 5 6.875 5C6.52083 5 6.22396 5.11979 5.98438 5.35938C5.74479 5.59896 5.625 5.89583 5.625 6.25C5.625 6.60417 5.74479 6.90104 5.98438 7.14062C6.22396 7.38021 6.52083 7.5 6.875 7.5Z",
    fill: "#655D57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructureIcon);
export default __webpack_public_path__ + "static/media/infrastructureIcon.369597d7e657be43fe241ac127652b08.svg";
export { ForwardRef as ReactComponent };